let storeContent = utils.generateStore({
	pendingFields: [],
	totalFields: 0,
	percentageComplete: 100,
	completed: 0,
	products: 0,
	notifications: 0,
	balance: {
		currency: 'Kes',
		bal: 0,
		accType: 'Main',
	},
	recommendations: [],
	catalogues: [],
	ads: [],
	invoices: [],
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchAccounts(ctx) {
			try {
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'get',
						data: {},
					},
					'/client',
				);

				// Get account balance
				let balance = 0,
					currency = '';

				for (let i = 0; i < res.result.client_accounts.length; i++) {
					const account = res.result.client_accounts[i];
					balance += account.available_balance;
					currency = account.currency_code;
				}

				ctx.commit('balance', {
					bal: balance,
					currency,
					accType: 'All',
				});
			} catch (err) {
				throw err;
			}
		},
		async fetchSummary(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'summary',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('products', res.result.products);
				ctx.commit('notifications', res.result.notifications);
				if (res.accounts && res.accounts.length > 0) {
					ctx.commit('balance', {
						currency: res.result.accounts[0].currency_code,
						bal: res.result.accounts[0].available_balance,
						accType: res.result.accounts[0].account_type,
					});
				}

				await ctx.dispatch('fetchReomendations');
				await ctx.dispatch('fetchSponsoredAds');
			} catch (err) {
				throw err;
			}
		},
		async showInvoice(ctx, payload) {
			try {
				if (payload.invoice.invoice_status !== 'PAID') {
					payload.router.push({ name: 'Cart' });
				} else {
					payload.router.push({ name: 'Invoice' });
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchReomendations(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'profile',
						action: 'reccomendations',
						data: {},
					},
					'/client',
				);

				ctx.commit('recommendations', res.result.reccomendations);
			} catch (err) {
				throw err;
			}
		},
		async fetchProductCatalogue(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'subclass',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit('catalogues', res.result.insurance_sub_classes);
			} catch (err) {
				throw err;
			}
		},
		async fetchSponsoredAds(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'sponsored_ads',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('ads', res.result);
			} catch (err) {
				throw err;
			}
		},
		async fetchKYC(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'kyc',
						action: 'summary',
						data: {},
					},
					'/client',
				);

				let total =
					res.result.client_kyc_summary.pending_kyc.length +
					res.result.client_kyc_summary.provided_kyc.length;
				let percentage = Math.round(
					(res.result.client_kyc_summary.provided_kyc.length /
						total) *
						100,
				);
				ctx.commit('totalFields', total);
				ctx.commit('percentageComplete', percentage);
				ctx.commit(
					'completed',
					res.result.client_kyc_summary.provided_kyc.length,
				);
				ctx.commit(
					'pendingFields',
					res.result.client_kyc_summary.pending_kyc,
				);
			} catch (err) {
				throw err;
			}
		},
		async fetchInvoices(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice',
						action: 'list',
						data: {},
					},
					'/client',
				);

				if (res.result.client_invoices.invoices <= 4) {
					ctx.commit('invoices', res.result.client_invoices.invoices);
				} else {
					ctx.commit(
						'invoices',
						res.result.client_invoices.invoices.slice(0, 4),
					);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				Event.$emit('loader:show', true);
				// await ctx.dispatch('fetchKYC')
				await ctx.dispatch('fetchSummary');
				await ctx.dispatch('fetchInvoices');
				await ctx.dispatch('fetchAccounts');
				await ctx.dispatch('fetchProductCatalogue');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
	},
};
